import styled from "styled-components";

export const ButtonPrimary = styled.button`
    display: flex;
    //width: 100%;
    height: 40px;
    padding: 0px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    border-radius: 1px;
    background: var(--it-accent-blue);
    color: var(--it-bg-dark-1);

    /* Buttons big */
    font-family: "Basis Grotesque Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 16px */
    letter-spacing: 0.48px;
    text-transform: uppercase;
		cursor: pointer;
    transition: all 0.4s;

    svg path {
        transition: all 0.4s;
        fill: var(--it-bg-dark-1);
    }
    
    &:hover {
        background: var(--it-accent-dark);
        color: var(--it-text-white);

        svg path {
            fill: var(--it-text-white);
        }
    }

    &[data-red] {
        background: var(--it-text-red);
        &:hover {
            background: var(--it-text-dark-red);
        }
    }

    &[data-icon] {
        padding: 10px;
    }
`